import React, { useEffect, forwardRef, useState, useContext } from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
// import { createAction } from "@reduxjs/toolkit";
// import store from "../app/store";
import { useInterval } from "../hooks";
import DatePicker from "react-datepicker";
import { TableContext } from "../index";
import ChooseDeviceIpField from "./ChooseDeviceIpField";
import ChooseUserField from "./ChooseUserField";
import { useHistory } from "react-router-dom";
import * as urlService from "../view/urlService";
import { getDateInLogFormat } from "../utils";
import * as mlDetectionService from "./mlDetectionService";
import SearchInputV2 from "../view/SearchInputV2";
import { Download } from "lucide-react";
// import { Download, Activity, AlertTriangle, Sparkles, PlayCircle, Search } from "lucide-react";
// import * as configActionService from "./configActionService";
// import { ACTION_RESULTS_CHANGED_VIEW_MODE } from "./MlDetectionPageReducer";

function MlDetectionTableHeader({ allResults = [], userCapability }) {

    const history = useHistory();
    const [selectedDate, setSelectedDate] = useState(null);
    const { config, setConfig } = useContext(TableContext);

    // Search state
    const [searchTerm, setSearchTerm] = useState('');
    // const [latestAnalysis, setLatestAnalysis] = useState(null);
    // const [analysisLoading, setAnalysisLoading] = useState(false);

    // const activeService = config.viewMode === "config" ? "config-action" : "login";
    // const visibleResults = (allResults || []).filter((item) => {
    //     const service = (item.service || '').toLowerCase();
    //     return activeService === "config-action" ? service === "config-action" : service !== "config-action";
    // });
    // const suspiciousCount = visibleResults.filter((item) => {
    //     const result = String(item.detectionResults || '').toLowerCase();
    //     return ["anomaly", "suspicious", "high_risk", "high-risk"].includes(result);
    // }).length;
    // const currentModeLabel = config.viewMode === "config" ? "Config Action" : "Login Count";

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    };

    //#region Set User Capabilities
    const [exportDataCapability, setExportDataCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const exportDataPermission = userCapability.find(item =>
                item.component === "exportdata" && item.type === "field")?.permission;
            setExportDataCapability(exportDataPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion


    // useEffect(() => {
    //     //getMlDetectionResults();
    //     /* eslint-disable react-hooks/exhaustive-deps */
    // }, [config.viewMode])

    //Execute the API Call of Get ML Results from database every 1 min 
    useInterval(() => getMlDetectionResults(), 120000);

    // const getMlDetectionResults = async () => {
    //     const allResults = config.viewMode === "config"
    //         ? await configActionService.list()
    //         : await mlDetectionService.list();
    //     setConfig({ ...config, allResults, lastUpdated: Date.now() });
    // }

    const getMlDetectionResults = async () => {
        const results = await mlDetectionService.listPageable;
        const allResults = await mlDetectionService.list;
        setConfig({ ...config, results: results, allResults: allResults });
    }

    const onDateChange = (date) => {
        setSelectedDate(date);
        const formatDate = getDateInLogFormat(date);

        const result = allResults.find(result => result.date.split(" ")[0] === formatDate);
        const dateFilter = result ? result.date.split(" ")[0] : formatDate;
        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('date', dateFilter)
        })
    }

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button type="button" className="btn oct_btn-datefrom-v2 oct_datepicker-fullwidth" onClick={onClick} ref={ref}>
            {value || 'Select a date'}
        </button>
    ));
    const exportData = () => {
        mlDetectionService.exportMachineLearningData();
    }

    // const getDatepickerDates = () => {
    //     //filter duplicate values based on date field
    //     const resultsDates = allResults.filter(
    //         (obj, index, self) => index === self.findIndex((o) => o.date === obj.date)
    //     );
    //     const availableDates = [];
    //     resultsDates.forEach((presult) => {
    //         const resultDate = convertMLDateTimeToDateFormat(presult.date)
    //         availableDates.push(resultDate);
    //     });

    //     return availableDates;
    // }

    // const exportData = () => {
    //     mlDetectionService.exportMachineLearningData();
    // }
    
    // const exportData = () => {
    //     if (config.viewMode === "config") {
    //         configActionService.exportMachineLearningData();
    //         return;
    //     }
    //     mlDetectionService.exportMachineLearningData();
    // }

    // const setViewMode = (viewMode) => {
    //     setConfig({ ...config, viewMode });
    //     store.dispatch(createAction(ACTION_RESULTS_CHANGED_VIEW_MODE)({ viewMode }));
    // };

    // const runConfigActionAnalysis = async () => {
    //     setAnalysisLoading(true);
    //     try {
    //         const result = await configActionService.analyzeLatestConfigAction();
    //         setLatestAnalysis(result);
    //         await getMlDetectionResults();
    //     } finally {
    //         setAnalysisLoading(false);
    //     }
    // };

    // const availableDates = getDatepickerDates();

    // return (
    //     <>
    //         <div className="oct_analysis-header-v2 oct_ml-results-header mt-0">
    //             <div className="oct_analysis-title-section oct_ml-results-header__title">
    //                 <div className="oct_ml-results-header__eyebrow">Results workspace</div>
    //                 <h2>ML Detection Results</h2>
    //                 {/* <p className="oct_ml-results-header__subtitle">
    //                     Track detections, switch analysis mode, and review suspicious activity with a cleaner summary view.
    //                 </p> */}
    //             </div>
    //             {/* <div className="oct_ml-mode-switch" role="tablist" aria-label="Detection type">
    //                 <div className="oct_ml-mode-switch__label">Detection mode</div>
    //                 <div className="oct_ml-mode-switch__group">
    //                     <button
    //                         type="button"
    //                         className={`oct_ml-mode-switch__button ${config.viewMode === "login" ? "is-active" : ""}`}
    //                         onClick={() => setViewMode("login")}
    //                     >
    //                         Login Count
    //                     </button>
    //                     <button
    //                         type="button"
    //                         className={`oct_ml-mode-switch__button ${config.viewMode === "config" ? "is-active" : ""}`}
    //                         onClick={() => setViewMode("config")}
    //                     >
    //                         Config Action
    //                     </button>
    //                 </div>
    //             </div> */}
    //         </div>

    //         <div className="oct_filter-section-v2">
    //             <div className="row align-items-end">
    //                 <div className="col">
    //                     <label className="oct_filter-label">User</label>
    //                     <ChooseUserField />
    //                 </div>
    //                 <div className="col">
    //                     <label className="oct_filter-label">Device IP</label>
    //                     <ChooseDeviceIpField />
    //                 </div>
    //                 <div className="col">
    //                     <label className="oct_filter-label">Date</label>
    //                     <DatePicker
    //                         selected={selectedDate}
    //                         onChange={onDateChange}
    //                         maxDate={new Date()}
    //                         customInput={<DatePickerInput />}
    //                         placeholderText="Select a date"
    //                         dateFormat="dd/MM/yyyy"
    //                     />
    //                 </div>
    //                 <div className="col">
    //                     <button type="button" className="oct_btn-export-v2 oct_btn-fullwidth"
    //                         disabled={exportDataCapability === 0 ? true : false}
    //                         onClick={exportDataCapability === 0 ? null : () => exportData()}>
    //                         <Download className="oct_icon" />
    //                         Export Data
    //                     </button>
    //                 </div>
    //             </div>

    //             {/* Row 3: Search */}
    //             <div className="mt-3">
    //                 <SearchInputV2
    //                     value={searchTerm}
    //                     onChange={handleSearch}
    //                     placeholder="Search in results..."
    //                     className="m-0"
    //                 />
    //             </div>
    //         </div>

    //         {/* <div className="row g-3 mb-4">
    //             <div className="col-lg-4 col-md-6">
    //                 <div className="oct_ml-stat-card">
    //                     <div className="oct_ml-stat-card__icon">
    //                         <Activity size={18} />
    //                     </div>
    //                     <div className="oct_ml-stat-card__copy">
    //                         <span className="oct_ml-stat-card__label">Visible Records</span>
    //                         <strong className="oct_ml-stat-card__value">{visibleResults.length}</strong>
    //                         <span className="oct_ml-stat-card__hint">Records currently shown in the active mode</span>
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="col-lg-4 col-md-6">
    //                 <div className="oct_ml-stat-card oct_ml-stat-card--warning">
    //                     <div className="oct_ml-stat-card__icon">
    //                         <AlertTriangle size={18} />
    //                     </div>
    //                     <div className="oct_ml-stat-card__copy">
    //                         <span className="oct_ml-stat-card__label">Suspicious / High Risk</span>
    //                         <strong className="oct_ml-stat-card__value">{suspiciousCount}</strong>
    //                         <span className="oct_ml-stat-card__hint">Items that need closer review first</span>
    //                     </div>
    //                 </div>
    //             </div>
    //             <div className="col-lg-4 col-md-12">
    //                 <div className="oct_ml-stat-card oct_ml-stat-card--accent">
    //                     <div className="oct_ml-stat-card__icon">
    //                         <Sparkles size={18} />
    //                     </div>
    //                     <div className="oct_ml-stat-card__copy">
    //                         <span className="oct_ml-stat-card__label">Mode Focus</span>
    //                         <strong className="oct_ml-stat-card__value oct_ml-stat-card__value--text">{currentModeLabel}</strong>
    //                         <span className="oct_ml-stat-card__hint">
    //                             {config.viewMode === "config" ? "Config diff + validation correlation" : "Login anomaly result history"}
    //                         </span>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>

    //         <div className="oct_filter-section-v2 oct_ml-toolbar">
    //             <div className="oct_ml-toolbar__top">
    //                 <div className="oct_ml-toolbar__search">
    //                     <label className="oct_filter-label">Search Results</label>
    //                     <div className="oct_ml-toolbar__searchInput">
    //                         <Search className="oct_ml-toolbar__searchIcon" size={18} />
    //                         <SearchInputV2
    //                             value={searchTerm}
    //                             onChange={handleSearch}
    //                             placeholder="Search by user, IP, result, note, or snapshot..."
    //                             className="m-0"
    //                         />
    //                     </div>
    //                 </div>

    //                 <div className="oct_ml-toolbar__actions">
    //                     <button type="button" className="oct_btn-export-v2 oct_ml-toolbar__button"
    //                         disabled={exportDataCapability === 0 ? true : false}
    //                         onClick={exportDataCapability === 0 ? null : () => exportData()}>
    //                         <Download className="oct_icon" />
    //                         Export Data
    //                     </button>
    //                     {config.viewMode === "config" && (
    //                         <button type="button" className="oct_btn-export-v2 oct_ml-toolbar__button oct_ml-toolbar__button--primary"
    //                             onClick={runConfigActionAnalysis}
    //                             disabled={analysisLoading}>
    //                             <PlayCircle className="oct_icon" />
    //                             {analysisLoading ? "Analyzing..." : "Run Config Action Analysis"}
    //                         </button>
    //                     )}
    //                 </div>
    //             </div>

    //             <div className="row align-items-end g-3">
    //                 {config.viewMode === "login" && (
    //                 <div className="col-lg-4 col-md-6">
    //                     <label className="oct_filter-label">User</label>
    //                     <ChooseUserField />
    //                 </div>
    //                 )}
    //                 {config.viewMode === "login" && (
    //                 <div className="col-lg-4 col-md-6">
    //                     <label className="oct_filter-label">Device IP</label>
    //                     <ChooseDeviceIpField />
    //                 </div>
    //                 )}
    //                 {config.viewMode === "login" && (
    //                 <div className="col-lg-4 col-md-6">
    //                     <label className="oct_filter-label">Date</label>
    //                     <DatePicker
    //                         selected={selectedDate}
    //                         onChange={onDateChange}
    //                         maxDate={new Date()}
    //                         customInput={<DatePickerInput />}
    //                         placeholderText="Select a date"
    //                         dateFormat="dd/MM/yyyy"
    //                     />
    //                 </div>
    //                 )}
    //             </div>

    //             {config.viewMode === "config" && latestAnalysis && (
    //                 <div className="mt-3 oct_ml-analysis-feedback">
    //                     <div className="oct_ml-analysis-feedback__head">
    //                         <strong>Latest Config Action Analysis</strong>
    //                         <span>{latestAnalysis.label}</span>
    //                     </div>
    //                     <div className="oct_ml-analysis-feedback__meta">
    //                         <span>Risk {latestAnalysis.risk_score}/100</span>
    //                         <span>Confidence {latestAnalysis.confidence}/100</span>
    //                     </div>
    //                     <div className="oct_ml-analysis-feedback__reason">{latestAnalysis.reason}</div>
    //                 </div>
    //             )}
    //         </div> */}
    //     </>
    // );

    return (
        <>
            {/* Row 1: Title */}
            <div className="oct_analysis-header-v2 mt-0">
                <div className="oct_analysis-title-section">
                    <h2>ML DETECTION RESULTS</h2>
                </div>
            </div>

            {/* Row 2: Filters - User, Device IP, Date, Export */}
            <div className="oct_filter-section-v2">
                <div className="row align-items-end">
                    <div className="col">
                        <label className="oct_filter-label">User</label>
                        <ChooseUserField />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">Device IP</label>
                        <ChooseDeviceIpField />
                    </div>
                    <div className="col">
                        <label className="oct_filter-label">Date</label>
                        <DatePicker
                            selected={selectedDate}
                            onChange={onDateChange}
                            maxDate={new Date()}
                            customInput={<DatePickerInput />}
                            placeholderText="Select a date"
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="col">
                        <button type="button" className="oct_btn-export-v2 oct_btn-fullwidth"
                            disabled={exportDataCapability === 0 ? true : false}
                            onClick={exportDataCapability === 0 ? null : () => exportData()}>
                            <Download className="oct_icon" />
                            Export Data
                        </button>
                    </div>
                </div>

                {/* Row 3: Search */}
                <div className="mt-3">
                    <SearchInputV2
                        value={searchTerm}
                        onChange={handleSearch}
                        placeholder="Search in results..."
                        className="m-0"
                    />
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    debug("DetectionResults mapStateToProps", state);
    const mlDetectionPage = state.mlDetectionPage;
    const auth = state.auth;
    return {
        allResults: mlDetectionPage.allResults,
        userCapability: auth.userCapability,
    };
}

export default connect(mapStateToProps)(MlDetectionTableHeader);
